import { render } from "./SuperPowersSection.vue?vue&type=template&id=5c9d9e5d&scoped=true"
import script from "./SuperPowersSection.vue?vue&type=script&lang=js"
export * from "./SuperPowersSection.vue?vue&type=script&lang=js"

import "./SuperPowersSection.vue?vue&type=style&index=0&id=5c9d9e5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9d9e5d"]])

export default __exports__